import { DatePicker } from "antd";
import type { DatePickerProps } from "antd";
import type { Dayjs } from "dayjs";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
import "./index.scss";

const POPUP_ROOT_CLASS = "clip-datepicker-dropdown";

// 固定为单选 picker（IsMultiple = false），与直接使用 <DatePicker /> 行为一致
export type ClipDatePickerProps = DatePickerProps<Dayjs, false>;

/**
 * antd DatePicker 的项目封装，作用域化注入 KaloClip 深色设计稿样式，
 * 不影响其它（如 DateRange）picker。所有 DatePicker 属性透传。
 */
export const ClipDatePicker = (props: ClipDatePickerProps) => {
  const { className, classNames: callerClassNames, ...rest } = props;

  const popup = callerClassNames?.popup;
  const popupClassNames =
    typeof popup === "string"
      ? { root: classNames(POPUP_ROOT_CLASS, popup) }
      : { ...popup, root: classNames(POPUP_ROOT_CLASS, popup?.root) };

  return (
    <DatePicker
      {...rest}
      className={twMerge("clip-datepicker", className)}
      classNames={{ ...callerClassNames, popup: popupClassNames }}
    />
  );
};
